import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { AuthService } from '@app/core/services/auth.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-federated-redirect-overlay',
  templateUrl: './federated-redirect-overlay.component.html',
  styleUrls: ['./federated-redirect-overlay.component.scss'],
  imports: [CommonModule, TranslateModule]
})
export class FederatedRedirectOverlayComponent {
  private authService = inject(AuthService);

  isVisible = computed(() =>
    !!this.authService.isLoadingAFederated() && this.authService.isReturningFromRedirect()
  );
}
